import type { ExtractPropTypes, PropType } from 'vue'
import { apiProps } from '../../useApi'

export const selectProps = {
  ...apiProps,

  /**
   * 是否在select显示下拉框时重新获取选项
   * @default false
   */
  alwaysRefresh: {
    type: Boolean,
    default: false
  },
  /**
   * 是否显示操作区域
   * @default true
   */
  operatorVisible: {
    type: Boolean,
    default: true
  },

  /**
   * 新增条目的链接
   */
  createLink: {
    type: String
  },
  /**
   * 新增条目的权限
   */
  createPermission: {
    type: [String, Array] as PropType<string | string[]>
  }
}
export type SelectProps = ExtractPropTypes<typeof selectProps>
const icon = {
  type: String as PropType<string>,
  default: 'icon-metric'
}
const monospace = {
  type: Boolean as PropType<boolean>,
  default: true
}
const ellipsis = {
  type: Boolean as PropType<boolean>,
  default: true
}
export const iconOptionProps = {
  icon,
  monospace,
  ellipsis,
  active: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  selected: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false
  }
}
export type IconOptionProps = ExtractPropTypes<typeof iconOptionProps>
